import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/chinaHimo/banner.jpg'
import navColor from '../../assets/chinaHimo/nav/color.jpg'
import navBg from '../../assets/chinaHimo/nav/nav_bg.png'

import far1 from '../../assets/chinaHimo/nav/far1.png'
import far1_active from '../../assets/chinaHimo/nav/far1_c.png'
import far2 from '../../assets/chinaHimo/nav/far2.png'
import far2_active from '../../assets/chinaHimo/nav/far2_c.png'
import far3 from '../../assets/chinaHimo/nav/far3.png'
import far3_active from '../../assets/chinaHimo/nav/far3_c.png'
import son1 from '../../assets/chinaHimo/nav/son1.png'
import son1_active from '../../assets/chinaHimo/nav/son1_c.png'
import son2 from '../../assets/chinaHimo/nav/son2.png'
import son2_active from '../../assets/chinaHimo/nav/son2_c.png'
import son3 from '../../assets/chinaHimo/nav/son3.png'
import son3_active from '../../assets/chinaHimo/nav/son3_c.png'
import son4 from '../../assets/chinaHimo/nav/son4.png'
import son4_active from '../../assets/chinaHimo/nav/son4_c.png'
import son5 from '../../assets/chinaHimo/nav/son5.png'
import son5_active from '../../assets/chinaHimo/nav/son5_c.png'
import son6 from '../../assets/chinaHimo/nav/son6.png'
import son6_active from '../../assets/chinaHimo/nav/son6_c.png'
import son7 from '../../assets/chinaHimo/nav/son7.png'
import son7_active from '../../assets/chinaHimo/nav/son7_c.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(137.5),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(137.5),
    backgroundImage: `url(${navBg})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${calcRemFn(28)} ${calcRemFn(40)} 0`,
  },
  topBtnBaseCss: {
    width: calcRemFn(97),
    height: calcRemFn(28)
  },
  bottomBtnLayout: {
    justifyContent: 'center',
    padding: `${calcRemFn(10)} ${calcRemFn(20)} 0`,
  },
  bottomBtnBaseCss: {
    width: calcRemFn(80),
    height: calcRemFn(24)
  }
}

const navData = {
  // afterTomorrowSpec: true,
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son3,
        img_actived: son3_active
      },
      {
        key: '_i2',
        show: true,
        img: son4,
        img_actived: son4_active
      },
      {
        key: '_i3',
        show: true,
        img: son5,
        img_actived: son5_active
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son6,
        img_actived: son6_active
      },
      {
        key: '_i2',
        show: true,
        img: son7,
        img_actived: son7_active
      }
    ]
  }
}

const pictureList = [
  {
    key: '1_1',
    picNum: 2,
    pid: 102131
  },
  {
    key: '1_2',
    picNum: 2,
    pid: 102131
  },
  {
    key: '2_1',
    picNum: 2,
    pid: 102132
  },
  {
    key: '2_2',
    picNum: 1,
    pid: 102132
  },
  {
    key: '2_3',
    picNum: 2,
    pid: 102132
  },
  {
    key: '3_1',
    picNum: 2,
    pid: 102130
  },
  {
    key: '3_2',
    picNum: 2,
    pid: 102130
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/chinaHimo/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'blue',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })

  pictures.push({
    type: 'blue',
    son: [require(`../../assets/chinaHimo/ctn/end.jpg`)]
  })
  return pictures
}
const pictures = handlePictures(pictureList)

const topDiff = {
  firstSon: '_i1',
  top1_i1: 10,
  top1_i2: 23,
  top2_i1: 20,
  top2_i2: 46,
  top2_i3: 36,
  top3_i1: 60,
  top3_i2: 18,
}

export default {
  title: '中国的 海马体',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
